import React from 'react';
import StyledLink from './StyledLink';
import { getLinkColor, getLinkSize, getLinkFontFamily } from './helpers';
import { colors, typography } from '@99designs/ui/settings';

export interface BaseLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: React.ReactNode;
    size?: typography.FontFamilyLinksSize;
    color?: colors.Color;
    fontFamily?: typography.FontFamily;
    noUnderline?: boolean;
    forwardedRef?: Exclude<React.ClassAttributes<HTMLAnchorElement>['ref'], string>;
}

function BaseLink({
    children,
    color = 'puntRoad',
    size = 'root',
    fontFamily = 'text',
    noUnderline = false,
    forwardedRef,
    ...props
}: BaseLinkProps) {
    return (
        <StyledLink
            {...props}
            ref={forwardedRef}
            linkColor={getLinkColor(color)}
            size={getLinkSize(size)}
            linkFontFamily={getLinkFontFamily(fontFamily)}
            noUnderline={noUnderline}
        >
            {children}
        </StyledLink>
    );
}
export default BaseLink;
